jQuery(document).ready(function($) {

	$form = $('#competition form');
    
    var validator = $form.validate({
    	rules: {
    		'accounting_functions[]': {
    			required: true
    		}
	    },
    	ignore: ':not(:visible)',
		errorPlacement: function(error, element) {
            return false;
        },
		highlight: function(element) {
			if($(element).is(':checkbox') || $(element).is('select')) {
				$(element).parents('.label').addClass('error-field');
				$(element).parents('label').addClass('error-field');
			} else {
	       		$(element).parent('label').addClass('error-field');
			}
	    },
	    unhighlight: function(element) {
			if($(element).is(':checkbox') || $(element).is('select')) {
				$(element).parents('.label').removeClass('error-field');
				$(element).parents('label').removeClass('error-field');
			} else {
	       		$(element).parent('label').removeClass('error-field');
			}
	    }
    });

	$('.js-comp-validate').click(function() {
		$('#competition').removeClass('validation-off');
		
		if($form.valid()) {
			var $next = $('#' + $(this).data('next'));
			$next.removeClass('competition--hide');
			$([document.documentElement, document.body]).animate({
        		scrollTop: $next.offset().top
    		}, 1000);

    		$('#competition').addClass('validation-off');
		}
		
	});

	$.validator.addMethod('roles', function(value, elem, param) {
   		return $(".roles:checkbox:checked").length > 0;
	},"You must select at least one.");
 
});
